module.exports = "<div class=\"container\">\n  <h1 class=\"heading\">Сторінку не знайдено</h1>\n</div>"